import { render, staticRenderFns } from "./MenuBarBoldButton.vue?vue&type=template&id=115a867e"
import script from "./MenuBarBoldButton.vue?vue&type=script&lang=js"
export * from "./MenuBarBoldButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports